




























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import OrderTable from '@/components/OrderTable.vue';
import UserService from '@/services/api/user.service';
import Confirmation from '@/components/Confirmation.vue';
import { namespace, State } from 'vuex-class';
import { Permission, User, UserGroup, UserRole } from '@/interfaces/user.interface';
import PermissionsService from '../services/permissions.service';

const usersModule = namespace('users');
const ordersModule = namespace('orders');

@Component({
  components: {
    Confirmation,
    OrderTable
  }
})
export default class Home extends Vue {
  @ordersModule.Action fetchStatuses!: any;
  @ordersModule.Action fetchPriorities!: any;
  @ordersModule.Action fetchTransportModes!: any;
  @usersModule.Action fetchUsers!: any;
  @usersModule.Action fetchRoles!: any;
  @usersModule.Action fetchGroups!: any;
  @usersModule.Action fetchPermissions!: any;
  @usersModule.State permissions!: Permission[];
  @usersModule.Getter currentUser!: User;
  @usersModule.State roles!: UserRole[];
  @usersModule.State groups!: UserGroup[];
  @State isLoading: boolean;

  mini = false;

  logout() {
    UserService.logout();
  }

  get miniArrowStyle(): any {
    return {
      transform: `rotate(${this.mini ? -90 : 90}deg)`
    };
  }

  get user(): any {
    if (this.currentUser) {
      const role = this.roles && this.roles.find(r => r.uuid === this.currentUser.roleUuid) || {};
      const group = this.groups && this.groups.find(g => g.uuid === this.currentUser.groupUuid) || {};
      return {
        name: this.currentUser && (`${this.currentUser.firstName} ${this.currentUser.lastName}`),
        role: role.label,
        group: group.label,
        roleUuid: this.currentUser.roleUuid,
        groupUuid: this.currentUser.groupUuid
      };
    }

    return {};
  }

  mounted() {
    if (!UserService.isLoggedIn()) return;

    this.fetchStatuses();
    this.fetchPriorities();
    this.fetchTransportModes();
    this.fetchUsers();
    this.fetchRoles();
    this.fetchGroups();
    this.fetchPermissions();
    this.restoreSidebarState();
  }

  get canSeeUsersView(): boolean {
    return PermissionsService.can('users', 'create');
  }

  @Watch('mini')
  saveMiniState(): void {
    window.localStorage.setItem('sidebarMinimisedState', this.mini.toString());
  }

  private restoreSidebarState() {
    this.mini = window.localStorage.getItem('sidebarMinimisedState') === 'true';
  }
}
